module.exports = __webpack_public_path__ + "img/com71.be02f749.png";